/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SignupSubscriptionPlanService } from './signup-subscription-plan.service';
import { Observable } from 'rxjs';
import { JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import { SubscriptionTypeVoModel } from '@well/domain';
import { ToastMessageOptions } from 'primeng/api';
import { ErrorService } from '@irian-ro/shared-components-module';
import { WellContextService } from '@well/shared-providers';

@Component({
  selector: 'signup-subscription-plan-page',
  templateUrl: './signup-subscription-plan.component.html',
  styleUrls: ['./signup-subscription-plan.component.scss']
})
export class SignupSubscriptionPlanComponent implements OnInit {

  msg: Observable<ToastMessageOptions[]> | undefined = undefined;

  @Input() legalEntityUuid:any = null;
  @Output() save: EventEmitter<string> = new EventEmitter<string>();

  subscriptionTypes: Observable<JsonApiResource<SubscriptionTypeVoModel[], JsonApiListResourceMetadataBase>> | undefined = undefined;

  constructor(private signupSubscriptionPlanPageService: SignupSubscriptionPlanService,
              private errorService: ErrorService,
              private wellContextService: WellContextService) {
  }

  ngOnInit() {
    this.wellContextService.getLoggedInContext().subscribe((loggedInContext: any) => {
      this.subscriptionTypes = this.signupSubscriptionPlanPageService.getSubscriptionTypesByLegalEntity(loggedInContext.legalEntityUuid);
    })
  }

  onSelect(subscriptionTypeUuid: string) {

    return this.signupSubscriptionPlanPageService.createNewAccountStatusIfNotExistsForCurrentOwner()
      .subscribe(() => {
          this.save.next(subscriptionTypeUuid);
        },
        (error: any) => {
          this.msg = this.errorService.prepareErrorsForDisplay(error, 'signup.actions.errors');
        });
  }
}
